var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.3866C18.3513 1.3866 23.5 6.53532 23.5 12.8866C23.5 19.2379 18.3513 24.3866 12 24.3866C5.64872 24.3866 0.5 19.2379 0.5 12.8866C0.5 6.53532 5.64872 1.3866 12 1.3866Z",
    fill: "white",
    stroke: "url(#paint0_linear_11003_4541)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4291 9.87053L15.7794 9.11462C15.2284 8.53597 14.5655 8.07546 13.831 7.76113C13.0964 7.4468 12.3056 7.28522 11.5066 7.28621C8.24546 7.28621 5.59961 9.93206 5.59961 13.1932C5.59961 16.4544 8.24546 19.1002 11.5066 19.1002C12.7283 19.1002 13.92 18.7214 14.9176 18.0162C15.9152 17.311 16.6697 16.3139 17.0774 15.1622",
    stroke: "url(#paint1_linear_11003_4541)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3961 7.42499V12.0875C18.3961 12.1202 18.3831 12.1515 18.36 12.1746C18.3369 12.1976 18.3056 12.2106 18.273 12.2106H13.6105C13.5861 12.2106 13.5623 12.2034 13.542 12.1899C13.5218 12.1764 13.506 12.1571 13.4967 12.1346C13.4874 12.1121 13.4849 12.0874 13.4897 12.0635C13.4944 12.0396 13.5062 12.0177 13.5234 12.0005L18.1859 7.33793C18.2031 7.3207 18.2251 7.30896 18.249 7.3042C18.2729 7.29945 18.2976 7.30188 18.3201 7.31121C18.3426 7.32053 18.3618 7.33632 18.3754 7.35657C18.3889 7.37683 18.3961 7.40064 18.3961 7.42499Z",
    fill: "url(#paint2_linear_11003_4541)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11003_4541",
    x1: 12,
    y1: 32,
    x2: 32,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11003_4541",
    x1: 12,
    y1: 32,
    x2: 32,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11003_4541",
    x1: 12,
    y1: 32,
    x2: 32,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "res/media/reset.54a2ef189ba3562a4127aa153a589741.svg";
export { ForwardRef as ReactComponent };